module.exports = __webpack_public_path__ + "img/Arrow2.d53b5e9c.svg";